const firebaseConfig = {
    apiKey: "AIzaSyDzZWhdBz5bN2NfOyYW5ERKBkgt8AATVuk",
    authDomain: "qr-notifaction.firebaseapp.com",
    projectId: "qr-notifaction",
    storageBucket: "qr-notifaction.firebasestorage.app",
    messagingSenderId: "344745531066",
    appId: "1:344745531066:web:b3f13307370d2df0ccd483",
    measurementId: "G-4PEDPFM8Y5",
  };
export {firebaseConfig};  